export default __webpack_public_path__ + "static/media/top_bar-profilo-over.29414ff6.svg";